(function () {

  function setHeight(el, val) {
		if (typeof val === "function") val = val();
		if (typeof val === "string") el.style.height = val;
		else el.style.height = val + "px";
	}
	
	const equalheight = function(container){
		let currentTallest = 0,
				currentRowStart = 0,
				rowDivs = new Array(),
				$el,
				topPosition = 0;
	
		Array.from(document.querySelectorAll(container)).forEach((el,i) => {
			el.style.height = "auto";
			topPostion = el.offsetTop;
			if(currentRowStart != topPostion){
				for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
					setHeight(rowDivs[currentDiv], currentTallest)
				}
				rowDivs.length = 0;
				currentRowStart = topPostion;
				currentTallest = parseFloat(getComputedStyle(el, null).height.replace("px", ""))
				rowDivs.push(el);
			} else {
				rowDivs.push(el);
				currentTallest = (currentTallest < parseFloat(getComputedStyle(el, null).height.replace("px", ""))) ? (parseFloat(getComputedStyle(el, null).height.replace("px", ""))) : (currentTallest);
			}
			for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
				setHeight(rowDivs[currentDiv], currentTallest)
			}
		})
	}

  const breakpoint = window.matchMedia( '(min-width: 1px)' );
  let mySwiper;

  const breakpointChecker = function() {
    if ( breakpoint.matches === true ) {
			return enableSwiper();
		} 
  };
  const enableSwiper = function() {
    mySwiper = new Swiper('.js-reviews__slider', {
      slidesPerView: 1,
      spaceBetween: 20,
			navigation: {
        nextEl: ".review-button-next",
        prevEl: ".review-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        767: {
          slidesPerView: 2,
          spaceBetween: 25
        },
				1400: {
          slidesPerView: 3,
          spaceBetween: 25
        }
      }
    });
  }

  // keep an eye on viewport size changes
  breakpoint.addEventListener('change', () => {
    breakpointChecker();
  })

  // kickstart
  breakpointChecker();

  window.addEventListener("DOMContentLoaded", (event) => {
    equalheight('.reviews__slide')
	});

	window.addEventListener("resize", function(){
		setTimeout(function(){
			equalheight('.reviews__slide')
		})
	})
})();
